
<div class="flex-center">
  <div class="text-center">
    <h2>{{ 'DECISION.TITLE' | translate }}</h2>
    <p class="my-5">{{ 'DECISION.TEXT' | translate }}</p>

    <div class="row justify-content-center">
      <div class="col-xs-4 offset-xs-2">
        <a (click)="onComing($event)" class="btn btn-rounded btn-success">
          <i class="fa fa-thumbs-up mr-2"></i> {{ 'DECISION.BUTTONS.YES' | translate }}</a>
      </div>
      <div class="col-xs-4">
        <a (click)="onNotComing($event)" class="btn btn-rounded btn-danger">
          <i class="fa fa-exclamation mr-2"></i> {{ 'DECISION.BUTTONS.NO' | translate }}</a>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/components/decision/decision.component.html